import { FC } from "react";
import { twMerge } from "tailwind-merge";

import { t } from "i18n/i18n";
import { Banner } from "mds/components/Banner";
import { useAppSelector } from "store/index";
import { selectCurrentSectionId } from "store/selectors";
import { useNavigate } from "utils/routing";
import { sectionHomeUrl } from "utils/urls";

type EmptyTopicBannerProps = {
  className?: string;
};

export const EmptyTopicBanner: FC<EmptyTopicBannerProps> = ({ className }) => {
  const navigate = useNavigate();
  const sectionId = useAppSelector(selectCurrentSectionId);

  return (
    <Banner
      actionButtonText={t("page_detail_view.go_to_section_overview")}
      className={twMerge("w-full", className)}
      eventName="Empty topic - Go to section overview"
      kind="info"
      onAction={() => {
        if (sectionId) {
          navigate(sectionHomeUrl(sectionId));
        }
      }}
    >
      {t("page_detail_view.empty_topic_banner")}
    </Banner>
  );
};
